import { schema } from 'normalizr';

export const inviteSchema = new schema.Entity('invite', {}, {
  idAttribute: '_id',
});

export const inviteListSchema = [inviteSchema];
